"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyUserLibraryFeaturedV3 = void 0;
exports.userLibraryFeaturedV3SetMock = userLibraryFeaturedV3SetMock;
exports.userLibraryFeaturedV3 = userLibraryFeaturedV3;
exports.useQueryUserLibraryFeaturedV3 = useQueryUserLibraryFeaturedV3;
exports.useInfiniteQueryUserLibraryFeaturedV3 = useInfiniteQueryUserLibraryFeaturedV3;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function userLibraryFeaturedV3SetMock(mock) {
    setMock = mock;
}
async function userLibraryFeaturedV3(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-athenaeum-service/v3/user-library/featured`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.softwareNumber = params.softwareNumber;
    queryParams.doEnableScaling = params.doEnableScaling;
    queryParams.trim = params.trim;
    queryParams.returnFields = params.returnFields;
    queryParams.membershipType = params.membershipType;
    queryParams.workoutFilters = params.workoutFilters;
    queryParams.category = params.category;
    if (params.etag !== undefined) {
        headers.etag = params.etag;
    }
    if (params['If-None-Match'] !== undefined) {
        headers['If-None-Match'] = params['If-None-Match'];
    }
    if (params['X-Llama-Namespaces'] !== undefined) {
        headers['X-Llama-Namespaces'] = params['X-Llama-Namespaces'];
    }
    if (params['X-Llama-Log-Level'] !== undefined) {
        headers['X-Llama-Log-Level'] = params['X-Llama-Log-Level'];
    }
    if (params['Cache-Control'] !== undefined) {
        headers['Cache-Control'] = params['Cache-Control'];
    }
    if (params.Accept !== undefined) {
        headers.Accept = params.Accept;
    }
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfAthenaeumServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyUserLibraryFeaturedV3 = 'wolf-athenaeum-service:userLibraryFeaturedV3:get';
function useQueryUserLibraryFeaturedV3(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyUserLibraryFeaturedV3, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryUserLibraryFeaturedV3(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyUserLibraryFeaturedV3, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = userLibraryFeaturedV3(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=user-library-featured-v3.js.map